import React, { ReactElement } from 'react';

import { FONT_SIZES, FONT_WEIGHTS } from '~/constants/typography';
import COLORS from '~/constants/colors';

import { SwitchProps } from '../models';

function TextSwitch({
  label,
  active = false,
  callback,
  style,
  activeStyle,
  ...props
}: SwitchProps): ReactElement {
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    callback?.(event);
  };

  // Styling
  const textSwitchStyle = {
    display: 'inline-block',
    margin: '0 0.75em',
    lineHeight: '1.3em',
    fontSize: FONT_SIZES.action,
    color: COLORS.black,
    fontWeight: FONT_WEIGHTS.light,
    textAlign: 'center' as const,
    outline: 'none',
    cursor: 'pointer',
    ...style,
  };
  const textSwitchActiveStyle = {
    ...textSwitchStyle,
    color: COLORS.dodgerBlue,
    ...activeStyle,
  };
  const textSwitchLabelStyle = {
    pointerEvents: 'none' as const,
  };

  return (
    <div
      role="none"
      onMouseDown={handleClick}
      onTouchStart={handleClick}
      style={active ? textSwitchActiveStyle : textSwitchStyle}
      {...props}
    >
      <span style={textSwitchLabelStyle}>{label}</span>
    </div>
  );
}

export default TextSwitch;
